// extracted by mini-css-extract-plugin
module.exports = {"Container":"drawer-footer_Container__9bO8J"};